import React from 'react'
import useAppDispatch from './useAppDispatch';
import useReduxData from './useReduxData';
import { SETSEARCH } from '../redux/features/FilterData';
import FilterItem from '../utils/FilterItem';
import Konsole from '../utils/konsole/Konsole';
import { scrollToElementWithOffset } from '../utils/scrollToElementWithOffset';
const useSearchItem = () => {
    const dispatch = useAppDispatch();
    const redux_data = useReduxData();
    const { store: { allCategory },
        filterData: { search, filterCategory } } = redux_data;

    const handleSearch = (e: any) => {
        dispatch(SETSEARCH(e, FilterItem(e, allCategory)));
        scrollError(e);
    }
    const scrollError = (e: any) => {
        setTimeout(() => {
            let idName = e ? "Display-Category-Items" : "bottom-to-top";
            if (e && filterCategory?.length == 0) {
                idName = "bottom-to-top-menu";
            }
            // @@ scroll after search
            scrollToElementWithOffset(idName);
            return;
            // const element = document.getElementById(idName);
            // Konsole.log("elementelement", element);
            // if (element && idName != "bottom-to-top-menu") {
            //     element.scrollIntoView({
            //         behavior: "smooth",
            //         block: "nearest",
            //         inline: "nearest",
            //     });
            // } else if (element && idName == "bottom-to-top-menu") {
            //     // @@ scroll to top
            //     element.scrollIntoView({
            //         behavior: "smooth",
            //         block: "start",
            //         inline: "nearest",
            //     });
            // }
        }, 1);
    };

    const handleSearchClear = async () => {
        return new Promise(async (resolve, reject) => {
            if (search && filterCategory?.length == 0) {
                await dispatch(SETSEARCH('', []));
            }
            resolve("")
        })

    }

    return {
        handleSearch,
        handleSearchClear
    };
}

export default useSearchItem